import { put } from 'redux-saga/effects'
import { IPcr } from '../../pcr/store/pcr.types'
import { setNewPatient, setPatientInformation, setSearchImport } from '../store/patientInformation.actions'

export function* getPatientInformation(pcrDoc: IPcr) {
  const patientInformation = pcrDoc.patient?.patientInformation
  if (patientInformation && Object.keys(patientInformation).length !== 0) {
    yield put(setPatientInformation(patientInformation))
  } else {
    yield put(setSearchImport(false))
    yield put(setNewPatient(false))
  }
}
